import getCanvas from '../helpers/getCanvas';

const applyAttributes = (html) => {
  const canvas = getCanvas(html);
  const form = canvas.querySelector('form');

  if (!form) {
    return html;
  }

  const inputs = form.querySelectorAll('input:not([type="submit"])');
  const buttons = form.querySelectorAll('button, input[type="submit"]');

  form.classList.add('kbx-form');

  Array.from(inputs).forEach((input) => {
    input.classList.add('kbx-input');
  });

  Array.from(buttons).forEach((button) => {
    button.classList.add('kbx-btn');
    button.classList.add('kbx-btn-submit-form');
  });

  return canvas.innerHTML;
};

export default applyAttributes;



/** WEBPACK FOOTER **
 ** ./src/helpers/form/filters/factories/applyAttributes.js
 **/